import { render, staticRenderFns } from "./SearchPage.vue?vue&type=template&id=04755b99&"
import script from "./SearchPage.vue?vue&type=script&lang=ts&"
export * from "./SearchPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports